import EventsManager from 'managers/events.manager';
import { Store } from 'stores/type';

class VisibilityManager {
  private $store!: Store;

  public init(store: Store) {
    this.$store = store;

    EventsManager.on('BLUR', this.onHide);
    EventsManager.on('FOCUS', this.onShow);
    EventsManager.on('VISIBILITY_HIDDEN', this.onHide);
    EventsManager.on('VISIBILITY_VISIBLE', this.onShow);
  }

  private onShow = () => {
    this.$store.commit('VISIBILITY', true);
  }
  private onHide = () => {
    this.$store.commit('VISIBILITY', false);
  }
}

export default new VisibilityManager();
